import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { getStepDetails } from 'visa-store';
import { map as map$1 } from 'rxjs/internal/operators/map';
import * as errorUtils from 'error-message-utility';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/button';
import * as i8 from '@angular/forms';
import * as i9 from 'primeng/table';
import * as i10 from 'primeng/api';
import * as i11 from 'primeng/inputtext';
import * as i12 from 'primeng/tooltip';
import * as i13 from '@angular/material/icon';
import { BaseFeeCalculationLibraryService } from 'base-fee-calculation-library';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';

class DependentFeeCalculationLibraryService {
    constructor(http) {
        this.http = http;
    }
    getFeeCalculation(visatype, caseType, caseId, superTaskId, taskId) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/fees?superTaskId=${superTaskId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    resetFeeCalculation(visatype, caseType, caseId) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/fees/reset`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    postFeeCalculation(visatype, caseType, caseId, superTaskId, taskId, payload) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/addDependentVisaFees`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
DependentFeeCalculationLibraryService.ɵfac = function DependentFeeCalculationLibraryService_Factory(t) { return new (t || DependentFeeCalculationLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
DependentFeeCalculationLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: DependentFeeCalculationLibraryService, factory: DependentFeeCalculationLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DependentFeeCalculationLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["feeCalculationForm"];
function DependentFeeCalculationLibraryComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "a", 15);
    i0.ɵɵtext(2, "Check here");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " for USCIS Fee Schedule Link ");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, " Check here for USCIS Fee Schedule for Form I-131: ");
    i0.ɵɵelementStart(6, "a", 16);
    i0.ɵɵtext(7, "USCIS Fee Schedule");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DependentFeeCalculationLibraryComponent_ng_template_12_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r8 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r8.columnName, " ");
} }
function DependentFeeCalculationLibraryComponent_ng_template_12_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 20);
    i0.ɵɵtext(1, "Action");
    i0.ɵɵelementEnd();
} }
function DependentFeeCalculationLibraryComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_12_th_1_Template, 2, 1, "th", 17);
    i0.ɵɵtemplate(2, DependentFeeCalculationLibraryComponent_ng_template_12_th_2_Template, 2, 0, "th", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.disabledControls);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r17 = i0.ɵɵnextContext().$implicit;
    const rowData_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(rowData_r11[col_r17.columnKey]);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r17 = i0.ɵɵnextContext().$implicit;
    const rowData_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, rowData_r11[col_r17.columnKey], "USD"));
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.getGlobalErrorMessages("REQUIRED"), " ");
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_div_2_span_1_Template, 2, 1, "span", 29);
    i0.ɵɵtemplate(2, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_div_2_span_2_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r17 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r1.controls[col_r17.columnKey].errors == null ? null : _r1.controls[col_r17.columnKey].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r1.controls[col_r17.columnKey].invalid);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 27, 28);
    i0.ɵɵlistener("ngModelChange", function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r35); const col_r17 = i0.ɵɵnextContext(3).$implicit; const rowData_r11 = i0.ɵɵnextContext().$implicit; return (rowData_r11[col_r17.columnKey] = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_div_2_Template, 3, 2, "div", 3);
} if (rf & 2) {
    const col_r17 = i0.ɵɵnextContext(3).$implicit;
    const rowData_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r26 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵproperty("name", col_r17.columnKey)("ngModel", rowData_r11[col_r17.columnKey])("disabled", ctx_r26.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r1.controls[col_r17.columnKey].touched && _r1.controls[col_r17.columnKey].invalid);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
} if (rf & 2) {
    const col_r17 = i0.ɵɵnextContext(3).$implicit;
    const rowData_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, rowData_r11[col_r17.columnKey], "USD"), " ");
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-cellEditor");
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_1_Template, 3, 4, "ng-template", 25);
    i0.ɵɵtemplate(2, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_ng_template_2_Template, 2, 4, "ng-template", 26);
    i0.ɵɵelementEnd();
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_p_cellEditor_1_Template, 3, 0, "p-cellEditor", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r17 = i0.ɵɵnextContext().$implicit;
    const rowData_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", rowData_r11[col_r17.columnKey] >= 0);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_1_Template, 2, 1, "span", 3);
    i0.ɵɵtemplate(2, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_2_Template, 3, 4, "span", 3);
    i0.ɵɵtemplate(3, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_span_3_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r17 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r17.columnKey === "familyName");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r17.columnKey === "total");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r17.columnKey !== "familyName" && col_r17.columnKey !== "total");
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function DependentFeeCalculationLibraryComponent_ng_template_13_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r45); const rowData_r11 = i0.ɵɵnextContext().$implicit; const ctx_r43 = i0.ɵɵnextContext(); ctx_r43.onRowEditInit(rowData_r11); return ctx_r43.updateControls(true); });
    i0.ɵɵelementStart(1, "mat-icon", 32);
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r14.disabledControls || ctx_r14.enableEdit);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("click", function DependentFeeCalculationLibraryComponent_ng_template_13_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r48); const rowData_r11 = i0.ɵɵnextContext().$implicit; const ctx_r46 = i0.ɵɵnextContext(); ctx_r46.onRowEditSave(rowData_r11); return ctx_r46.updateControls(false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(8);
    i0.ɵɵproperty("disabled", ctx_r15.disabledControls || _r1.invalid);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("click", function DependentFeeCalculationLibraryComponent_ng_template_13_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(); const rowData_r11 = ctx_r50.$implicit; const ri_r10 = ctx_r50.rowIndex; const ctx_r49 = i0.ɵɵnextContext(); ctx_r49.onRowEditCancel(rowData_r11, ri_r10); return ctx_r49.updateControls(false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r16.disabledControls);
} }
function DependentFeeCalculationLibraryComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 21);
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_13_td_1_Template, 4, 3, "td", 17);
    i0.ɵɵelementStart(2, "td", 20);
    i0.ɵɵtemplate(3, DependentFeeCalculationLibraryComponent_ng_template_13_button_3_Template, 3, 1, "button", 22);
    i0.ɵɵtemplate(4, DependentFeeCalculationLibraryComponent_ng_template_13_button_4_Template, 1, 1, "button", 23);
    i0.ɵɵtemplate(5, DependentFeeCalculationLibraryComponent_ng_template_13_button_5_Template, 1, 1, "button", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const editing_r9 = ctx.editing;
    const rowData_r11 = ctx.$implicit;
    const columns_r12 = ctx.columns;
    i0.ɵɵproperty("pEditableRow", rowData_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r12);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !editing_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", editing_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", editing_r9);
} }
function DependentFeeCalculationLibraryComponent_ng_template_17_th_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Grand Total");
    i0.ɵɵelementEnd();
} }
function DependentFeeCalculationLibraryComponent_ng_template_17_th_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r53 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, col_r53.total, "USD"), " ");
} }
function DependentFeeCalculationLibraryComponent_ng_template_17_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 19);
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_17_th_1_span_1_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(2, DependentFeeCalculationLibraryComponent_ng_template_17_th_1_span_2_Template, 3, 4, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r53 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r53.columnKey === "familyName");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r53.columnKey !== "familyName");
} }
function DependentFeeCalculationLibraryComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, DependentFeeCalculationLibraryComponent_ng_template_17_th_1_Template, 3, 2, "th", 17);
    i0.ɵɵelement(2, "th", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.displayColumns);
} }
class DependentFeeCalculationLibraryComponent {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, appServicesLibraryService) {
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
        this.feeCalculation = [];
        this.enableEdit = false;
        this.displayColumns = [];
        this.dataObj = [];
        this.observableSubscription$ = new Subject();
        this.disabledControls = false;
        this.checked = true;
        this.clonedFees = {};
        this.feeTotal = 0;
    }
    ngAfterViewInit() {
        this.feeCalculationForm.form.valueChanges.pipe(map$1(() => this.feeCalculationForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.stepDetails = data;
            this.getFeeCalculation();
            this.toggleControlsStatus();
        });
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    getFeeCalculation() {
        this.apiService.getFeeCalculation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.feeCalculation = response['data'];
                //this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                this.buildDependentFee();
            }
        });
    }
    resetFeeCalucation() {
        this.apiService.resetFeeCalculation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.feeCalculation = response['data'];
                this.buildDependentFee();
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    postFeeCalculation() {
        this.feeCalculation.forEach(feeEntry => {
            var _a;
            if (((_a = feeEntry === null || feeEntry === void 0 ? void 0 : feeEntry.fees) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                feeEntry.fees.forEach(fee => {
                    fee.applicableFee = parseInt(this.dataObj.find(item => item.familyId === feeEntry.familyId)[fee.feeTypeCode]);
                });
            }
        });
        this.apiService.postFeeCalculation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.caseId, this.feeCalculation).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.toastr.success(response.message, 'Success');
            this.feeCalculation = response.data;
            this.feeCalculationForm.resetForm();
        });
    }
    onRowEditInit(item) {
        this.clonedFees = Object.assign({}, item);
    }
    onRowEditSave(item) {
        item['total'] = 0;
        Object.keys(item).forEach(key => {
            if (key !== 'familyName' && key !== 'total' && key !== 'familyId') {
                item['total'] += parseInt(item[key]);
            }
        });
        this.updateGrandTotal();
        this.clonedFees = null;
    }
    onRowEditCancel(item, index) {
        this.dataObj[index] = this.clonedFees;
        this.updateGrandTotal();
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    updateControls(status) {
        this.enableEdit = status;
    }
    buildDependentFee() {
        var _a;
        this.displayColumns = [{
                columnName: 'Applicant Name',
                columnKey: 'familyName'
            }];
        this.dataObj = [];
        if (((_a = this.feeCalculation) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.feeCalculation.forEach(el => {
                let total = 0;
                if (el['fees'] && el['fees'].length > 0) {
                    el['fees'].forEach(fee => {
                        this.displayColumns.push({
                            columnName: fee['feeTypeName'],
                            columnKey: fee['feeTypeCode'],
                            total: 0
                        });
                        //check if the family record is already in the dataObj
                        let familyIndex = this.dataObj.findIndex(item => item.familyId === el.familyId);
                        if (familyIndex >= 0) {
                            this.dataObj[familyIndex][fee['feeTypeCode']] = parseInt(fee.applicableFee);
                            this.dataObj[familyIndex]['total'] = parseInt(this.dataObj[familyIndex]['total']) + parseInt(fee.applicableFee);
                        }
                        else {
                            this.dataObj.push({
                                familyId: el.familyId,
                                familyName: el.familyName,
                                [fee['feeTypeCode']]: parseInt(fee.applicableFee) || 0,
                                total: total + parseInt(fee.applicableFee)
                            });
                        }
                    });
                }
            });
            this.displayColumns.push({
                columnName: 'Total',
                columnKey: 'total',
                total: 0
            });
            this.displayColumns = this.displayColumns.filter((type, i, arr) => arr.findIndex(t => t.columnKey === type.columnKey) === i);
            this.updateGrandTotal();
        }
    }
    updateGrandTotal() {
        this.displayColumns.forEach(col => {
            let colTotal = 0;
            this.dataObj.forEach(item => {
                Object.keys(item).find(key => {
                    if (key !== 'familyName' && key !== 'familyId') {
                        if (col === 'total') {
                            colTotal += parseInt(item[key]);
                        }
                        else if (key === col.columnKey) {
                            colTotal += parseInt(item[key]);
                        }
                    }
                });
            });
            col.total = colTotal;
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
DependentFeeCalculationLibraryComponent.ɵfac = function DependentFeeCalculationLibraryComponent_Factory(t) { return new (t || DependentFeeCalculationLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(DependentFeeCalculationLibraryService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.AppServicesLibraryService)); };
DependentFeeCalculationLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DependentFeeCalculationLibraryComponent, selectors: [["lib-dependent-fee-calculation-library"]], viewQuery: function DependentFeeCalculationLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.feeCalculationForm = _t.first);
    } }, inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, decls: 20, vars: 6, consts: [[1, "row", "col-md-12", "d-flex", "align-items-center", "pb-2"], [1, "col-6"], [1, "heading", "pl-0"], [4, "ngIf"], [1, "col-md-6", "pull-right"], ["type", "button", "pButton", "", "label", "Reset", 1, "p-button-outlined", "pull-right", "btn", 3, "disabled", "click"], [3, "ngSubmit"], ["feeCalculationForm", "ngForm"], [1, "row"], [1, "col", "pr-0"], ["dataKey", "familyId", "editMode", "row", 1, "uscis-table", "table-striped-simple", 3, "columns", "value"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "row", "col-md-12", "pt-3"], ["pButton", "", "type", "submit", "label", "Save", 3, "ngClass", "disabled"], ["href", "https://www.uscis.gov/sites/default/files/document/forms/g-1055.pdf", "target", "_blank", "rel", "noopener noreferrer"], ["href", "https://www.uscis.gov/g-1055?form=i-131", "target", "_blank", "rel", "noopener noreferrer"], ["colspan", "2", 4, "ngFor", "ngForOf"], ["colspan", "2", "class", "text-center", 4, "ngIf"], ["colspan", "2"], ["colspan", "2", 1, "text-center"], [3, "pEditableRow"], ["pButton", "", "pRipple", "", "type", "button", "pInitEditableRow", "", "pTooltip", "Edit", "class", "p-button-rounded p-button-text", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "pSaveEditableRow", "", "icon", "pi pi-check", "class", "p-button-rounded p-button-text p-button-success p-mr-2", 3, "disabled", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "pCancelEditableRow", "", "icon", "pi pi-times", "class", "p-button-rounded p-button-text p-button-danger", 3, "disabled", "click", 4, "ngIf"], ["pTemplate", "input"], ["pTemplate", "output"], ["pInputText", "", "type", "text", "maxlength", "5", "pattern", "^[0-9]*$", "min", "0", "required", "", 3, "name", "ngModel", "disabled", "ngModelChange"], ["[col.columnKey]", "ngModel"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], ["pButton", "", "pRipple", "", "type", "button", "pInitEditableRow", "", "pTooltip", "Edit", 1, "p-button-rounded", "p-button-text", 3, "disabled", "click"], ["matTooltip", "Edit", 1, "mr-1", "icn"], ["pButton", "", "pRipple", "", "type", "button", "pSaveEditableRow", "", "icon", "pi pi-check", 1, "p-button-rounded", "p-button-text", "p-button-success", "p-mr-2", 3, "disabled", "click"], ["pButton", "", "pRipple", "", "type", "button", "pCancelEditableRow", "", "icon", "pi pi-times", 1, "p-button-rounded", "p-button-text", "p-button-danger", 3, "disabled", "click"]], template: function DependentFeeCalculationLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h6", 2);
        i0.ɵɵtext(3, "View Fees");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DependentFeeCalculationLibraryComponent_span_4_Template, 8, 0, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "button", 5);
        i0.ɵɵlistener("click", function DependentFeeCalculationLibraryComponent_Template_button_click_6_listener() { return ctx.resetFeeCalucation(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "form", 6, 7);
        i0.ɵɵlistener("ngSubmit", function DependentFeeCalculationLibraryComponent_Template_form_ngSubmit_7_listener() { return ctx.postFeeCalculation(); });
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "p-table", 10);
        i0.ɵɵtemplate(12, DependentFeeCalculationLibraryComponent_ng_template_12_Template, 3, 2, "ng-template", 11);
        i0.ɵɵtemplate(13, DependentFeeCalculationLibraryComponent_ng_template_13_Template, 6, 5, "ng-template", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 8);
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵelementStart(16, "p-table");
        i0.ɵɵtemplate(17, DependentFeeCalculationLibraryComponent_ng_template_17_Template, 3, 1, "ng-template", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵelement(19, "button", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(8);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.inputData == null ? null : ctx.inputData.immigrationCategory) !== "EOIR");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("columns", ctx.displayColumns)("value", ctx.dataObj);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngClass", _r1.invalid || ctx.disabledControls ? "btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn btn-primary" : "btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn btn-primary")("disabled", _r1.invalid || ctx.disabledControls);
    } }, directives: [i6.NgIf, i7.ButtonDirective, i8.ɵangular_packages_forms_forms_ba, i8.NgControlStatusGroup, i8.NgForm, i9.Table, i10.PrimeTemplate, i6.NgClass, i6.NgForOf, i9.EditableRow, i9.CellEditor, i8.DefaultValueAccessor, i11.InputText, i8.MaxLengthValidator, i8.PatternValidator, i8.RequiredValidator, i8.NgControlStatus, i8.NgModel, i9.InitEditableRow, i12.Tooltip, i13.MatIcon, i9.SaveEditableRow, i9.CancelEditableRow], pipes: [i6.CurrencyPipe], styles: [".uscis-table[_ngcontent-%COMP%]{color:#888;border-top:none!important;font-size:13px}.uscis-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;color:#4a4a4a;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.uscis-table[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0 0 10px!important;color:#4a4a4a}.uscis-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #e9ecef}.save-btn[_ngcontent-%COMP%]{border-top:1px solid #e9ecef}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DependentFeeCalculationLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-dependent-fee-calculation-library',
                templateUrl: 'dependent-fee-calculation-library.component.html',
                styleUrls: ['dependent-fee-calculation-library.component.scss']
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.ToastrService }, { type: DependentFeeCalculationLibraryService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, { feeCalculationForm: [{
            type: ViewChild,
            args: ['feeCalculationForm', { static: true }]
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class DependentFeeCalculationLibraryModule {
}
DependentFeeCalculationLibraryModule.ɵfac = function DependentFeeCalculationLibraryModule_Factory(t) { return new (t || DependentFeeCalculationLibraryModule)(); };
DependentFeeCalculationLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: DependentFeeCalculationLibraryModule });
DependentFeeCalculationLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseFeeCalculationLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DependentFeeCalculationLibraryModule, { declarations: [DependentFeeCalculationLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule], exports: [DependentFeeCalculationLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DependentFeeCalculationLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DependentFeeCalculationLibraryComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                ],
                exports: [
                    DependentFeeCalculationLibraryComponent
                ],
                providers: [BaseFeeCalculationLibraryService]
            }]
    }], null, null); })();

/*
 * Public API Surface of dependent-fee-calculation-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DependentFeeCalculationLibraryComponent, DependentFeeCalculationLibraryModule, DependentFeeCalculationLibraryService };
//# sourceMappingURL=dependent-fee-calculation-library.js.map
